import React, { useState } from 'react';
import { Button } from '../Button/Button';
import { Modal } from './Modal';
import { ControlledModal, ModalController } from './ControlledModal';
import { delay } from '../../util/util';

interface Model {
  title: string;
}

export function ModalExample(): JSX.Element {
  const [displayModal, setDisplayModal] = useState(false);
  const [displayControlledModalValue, setDisplayControlledModalValue] = useState<Model | undefined>(undefined);
  const [displaySideModal, setDisplaySideModal] = useState(false);

  const [modalSize, setModalSize] = useState<'large' | 'small'>('large');

  return (
    <div>
      <Button onClick={() => setDisplayModal(true)} title="Open modal" />
      <Button onClick={() => setDisplayControlledModalValue({ title: 'Hello World' })} title="Open controlled modal" />
      <Button onClick={() => setDisplaySideModal(true)} title="Open Side modal" />
      <Modal
        open={displayModal}
        title="This is a Modal"
        size={modalSize}
        className="styleguide__modal"
        footer={
          <>
            <Button onClick={() => setModalSize(modalSize === 'small' ? 'large' : 'small')} title="CHANGE SIZE" />
            <Button onClick={() => setDisplayModal(false)} title="CLOSE MODAL" type="primary" />
          </>
        }
      >
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta provident, eligendi eveniet saepe aperiam iure,
        reprehenderit ipsam temporibus assumenda eum eos voluptatibus magnam aut minus libero doloremque aspernatur quod
        tenetur?
      </Modal>
      <Modal
        open={displaySideModal}
        title="This is a Modal"
        size={modalSize}
        className="styleguide__modal"
        position="aside"
        footer={
          <>
            <Button onClick={() => setModalSize(modalSize === 'small' ? 'large' : 'small')} title="CHANGE SIZE" />
            <Button onClick={() => setDisplaySideModal(false)} title="CLOSE MODAL" type="primary" />
          </>
        }
      >
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta provident, eligendi eveniet saepe aperiam iure,
        reprehenderit ipsam temporibus assumenda eum eos voluptatibus magnam aut minus libero doloremque aspernatur quod
        tenetur?
      </Modal>
      <ControlledModal
        title="test title"
        open={!!displayControlledModalValue}
        model={displayControlledModalValue}
        onClose={() => setDisplayControlledModalValue(undefined)}
      >
        {(controller) => <ModalEditor controller={controller} />}
      </ControlledModal>
    </div>
  );
}

function ModalEditor(props: { controller: ModalController<{ title: string }> }): JSX.Element {
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const { controller } = props;
  controller.configure({
    canSubmit: submitEnabled,
    onSubmit: async () => {
      await delay(2);
      controller.close();
    },
    onCancel: controller.close,
  });
  return (
    <div>
      <h2>{controller.model.title}</h2>
      <Button title="enable submit" onClick={() => setSubmitEnabled(true)} type="primary" />
    </div>
  );
}
